import React, {useEffect, useMemo, useState} from "react";

/**
 * 아카이브 > 회고록 > 목록 > 연도별 컴포넌트
 */

const BiographyYear = ({paramSelectedYear, propYearArray, handleSearchYear}) => {
    const [selectedYear, setSelectedYear] = useState(paramSelectedYear || null);
    const [yearsRange, setYearsRange] = useState([]);

    // 중복되지 않은 연도 리스트
    const uniqueYears = useMemo(() => {
        return [...new Set(propYearArray.map(item => item.publish_year))];
    }, [propYearArray]);

    // uniqueYears를 Set으로 변환하여 빠른 검색 가능하도록 설정
    const uniqueYearsSet = useMemo(() => new Set(uniqueYears), [uniqueYears]);

    useEffect(() => {
        const min = Math.min(...uniqueYears);
        const max = Math.max(...uniqueYears);
        setYearsRange(Array.from({ length: max - min + 1 }, (_, i) => min + i));
    }, [uniqueYears]);

    const onSelectedYear = (year) => {
        if (uniqueYearsSet.has(year)) {
            handleSearchYear(year);
        }
    };
    useEffect(() => {
        const newYear = paramSelectedYear ? parseInt(paramSelectedYear) : null;
        if (selectedYear !== newYear) {
            setSelectedYear(newYear);
        }
    }, [paramSelectedYear]);
    
    return (
        <div className="year-wrap">
            <div className="year-slides">
                <ul className="slides-wrapper">
                    {yearsRange.map((year) => {
                        return (
                            <li
                                className={selectedYear === year || parseInt(paramSelectedYear) === year ? 'on' : ''}
                                key={year}
                                onClick={() => uniqueYearsSet.has(year) && onSelectedYear(year)} // 데이터가 있는 경우에만 클릭 이벤트 활성화
                                disabled={!uniqueYearsSet.has(year)} // 데이터가 없는 경우 버튼 비활성화
                            >
                                {year}
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default BiographyYear;
